import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {CategoryService} from '../../../services/category.service';
import {Err} from '../../../err';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  form: FormGroup;
  categories;
  subcategories;
  selectedCategory;
  showAdd;
  showDelete;
  subcategory;
  newName;
  isLoading = false;
  submitted = false;
  message = '';

  constructor(private categoryService: CategoryService,
              private builder: FormBuilder,
              public translate: TranslateService) {
    translate.use('nl');
    this.form = builder.group({
      'name': ['', [Validators.required]]
    });

    this.showAdd = false;
    this.showDelete = false;
    this.newName = '';
    this.selectedCategory = '';
  }

  ngOnInit() {
    this.getAllSubcategories();
  }

  getSubcategories(cat) {
    console.log('unsupportedfeatureexception');
  }

  showAddForm() {
    this.showAdd = true;
    this.selectedCategory = '';
  }

  cancel() {
    this.showAdd = false;
    this.message = '';
  }

  addSubcategory(category, name) {
    if (name !== '') {
      const subcategory = {name: name, categoryId: category.id};
      this.categoryService.addSubcategory(subcategory).subscribe((data) => {
        this.getSubcategories(category);
        this.newName = '';
      });
    }
  }

  deleteSubcategory(cat, id) {
    this.categoryService.deleteSubcategory(id)
      .subscribe(() => this.getSubcategories(cat));
  }

  hideSubcategory() {
    this.selectedCategory = '';
  }

  getAllSubcategories() {
    this.categoryService.getSubcategories().subscribe(data => this.subcategories = data);
  }
}
